import { Controller } from "@hotwired/stimulus";
import { Toast } from "bootstrap";

export default class extends Controller {
  connect() {
    const showToast = (element) => {
      const toast = Toast.getOrCreateInstance(element);
      toast.show();
      return toast;
    };

    this.element.querySelectorAll(".toast").forEach(showToast);

    const newChild = (mutationList) => {
      mutationList
        .filter((mutation) => mutation.type === "childList")
        .forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType !== Node.ELEMENT_NODE) return;
            if (node.classList.contains("toast")) return showToast(node);
            node.querySelectorAll(".toast").forEach(showToast);
          });
        });
    };

    this.observer = new MutationObserver(newChild);
    this.observer.observe(this.element, { childList: true });
  }

  disconnect() {
    // this.observer.disconnect();
  }
}
